import { withInstall } from '@ll-plus/utils'

import TextParagraph from './src/text-paragraph.vue'
import Text from './src/text.vue'

export const LlText = withInstall(Text)
export const LlTextParagraph = withInstall(TextParagraph)

export * from './src/text'

declare module 'vue' {
  export interface GlobalComponents {
    LlText: typeof Text
    LlTextParagraph: typeof TextParagraph
  }
}
